<div class="row">
  <span class="gacha-icon">☀</span>
  <span class="bal">{{ pointsBalance() }}</span>
  <span class="spacer"></span>
  <button class="roll" (click)="gachaModal.open()">
    @if (mobile.isMobile) { Roll Gacha! } @else { Roll Gacha! ({{ rollCost() }}
    <span class="gacha-icon">☀</span>) }
  </button>
</div>
